import { IImage } from "@boma/website/shared/entities";

export interface IDepartment {
  id: string;
  name: string;
  icon: IImage;
  banner: IImage;
  createdAt: Date;
  updatedAt: Date;
}
